<ul class="nav nav-tabs content" role="tablist">
    <!-- <li role="presentation" class="active"><a href="#active-plans" role="tab" data-toggle="tab" aria-expanded="true">{{'Common.Active-Plans'|translate}}</a></li>
    <li role="presentation" class=""><a href="#inactive-plans" role="tab" data-toggle="tab" aria-expanded="false">{{'Common.Inactive-Plans'|translate}}</a></li> -->
    <a *ngIf="contentKey" class="instructions large" href="#instructions" data-toggle="modal"><i>{{'HelpText.Help' |translate}}</i></a>
</ul>




<div class="modal fade" style="z-index: 9999;" id="instructions" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <a href="javascript:void(0)">
          <span class="close" data-dismiss="modal" aria-label="Close"></span>
        </a>

        <div class="title"   [innerHTML]="'HelpText'+'.'+contentKey|translate" ></div>
        <!-- <div class="sub-title center">{{'HelpText.HelpPopUpDesc'|translate}} </div>   {{'HelpText'+'.'+item|translate}}-->
      </div>
    </div>
  </div>